import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SkeletonImage, SkeletonButton } from '@xingternal/skeleton';
import { Headline } from '@xingternal/typography';
import { SmallGrid } from '@xingternal/pages-common';

import styles from './PagesFormSkeleton.css';

export type SkeletonProps = {
  headlineKey?: string;
};

const Skeleton = ({ headlineKey }: SkeletonProps) => (
  <>
    <div>
      {headlineKey && (
      <Headline size={'xxlarge'}>
        <FormattedMessage id={headlineKey} />
      </Headline>
      )}
      <SmallGrid>
        <SkeletonImage
          variant="primary"
          size="small"
          className={styles.field}
        />
        <SkeletonImage
          variant="primary"
          size="small"
          className={styles.field}
        />
        <SkeletonImage
          variant="primary"
          size="small"
          className={styles.field}
        />
        <SkeletonImage
          variant="primary"
          size="small"
          className={styles.field}
        />
      </SmallGrid>
    </div>
    <div className={styles.actions}>
      <SkeletonButton
        variant="primary"
        size="medium"
        className={styles.publishButtonSkeleton}
      />
    </div>
  </>
);

export default Skeleton;
